export const BILLING_ENTRYPOINTS = {
  PROFILE_DROPDOWN: 'profile_dropdown',
  LEFT_NAV: 'left_nav',
  PAYWALL: 'paywall',
  TRIAL_LOSS_MODAL: 'active_session_free_form',
  TRIAL_START_MODAL: 'trial_start_post_intro_flow_modal',
  RETRIAL_MODAL: 'retrial_modal',
  TOP_RIGHT_HEADER: 'top_right_header',
  NOTETAKER_TRIAL_OPT_IN_MODAL: 'notetaker_trial_start_opt_in_modal',
  NOTETAKER_TRIAL_OPT_OUT_MODAL: 'notetaker_trial_start_opt_out_modal',
  RECAPS_PAGE: 'recaps_page',
  MEETINGS_PAGE: 'meetings_page',
  RECAPS_DETAIL_PAGE: 'recaps_detail_page'
}

/** Value for Paywall Shown paywall_feature when the paywall is launched from free recaps CTAs (usage metering). */
export const NOTETAKER_FREE_MEETINGS_PAYWALL_FEATURE = 'notetaker_free_meetings_1'

export const MODAL_NAMES = {
  PRE_TRIAL_FEATURE_START: 'trial_start_post_intro_flow',
  PRE_TRIAL_END_FEATURE_LOSS: 'pre_trial_end_feature_loss',
  POST_TRIAL_FEATURE_LOSS: 'post_trial_end_feature_loss',
  PRE_TRIAL_END_FEATURE_LOSS_FORCED: 'pre_trial_end_feature_loss_forced',
  POST_TRIAL_FEATURE_LOSS_FORCED: 'post_trial_end_feature_loss_forced',
  UPGRADE_PLAN: 'upgrade_plan',
  RETRIAL_OFFER: 'start_another_free_trial',
  NOTETAKER_OPT_IN: 'notetaker_free_trial_opt_in',
  NOTETAKER_OPT_OUT: 'notetaker_free_trial_opt_out'
}

export const MODAL_DETAILS = {
  TRIAL_STARTED: 'your_14_day_free_trial_has_started',
  RETRIAL_OFFER: 'were_giving_you_another_free_trial',
  NOTETAKER_OPT_IN: 'unlocked_notetaker_free_trial',
  NOTETAKER_OPT_OUT: 'notetaker_free_trial_now_active'
}

export const MODAL_ACTION = {
  OPENING: 'opening',
  DISMISSED: 'dismissed',
  START_TRIAL: 'start_free_trial'
}

export const STRIPE_API_VERSION = '2025-05-28.basil'

const TRIAL_PERIOD_14_DAYS = 14

export const getModalName = ({
  isTrialActive,
  forceCtaInteraction,
  trialEndsInDays
}) => {
  if (isTrialActive) {
    if (trialEndsInDays === TRIAL_PERIOD_14_DAYS) {
      return MODAL_NAMES.PRE_TRIAL_FEATURE_START
    }
    if (forceCtaInteraction) {
      return MODAL_NAMES.PRE_TRIAL_END_FEATURE_LOSS_FORCED
    }
    return MODAL_NAMES.PRE_TRIAL_END_FEATURE_LOSS
  }
  if (forceCtaInteraction) {
    return MODAL_NAMES.POST_TRIAL_FEATURE_LOSS_FORCED
  }
  return MODAL_NAMES.POST_TRIAL_FEATURE_LOSS
}

export const CURRENCY_MAP = {
  BRL: '🇧🇷 BRL R$',
  AUD: '🇦🇺 AUD $',
  EUR: '🇪🇺 EUR €',
  GBP: '🇬🇧 GBP £',
  INR: '🇮🇳 INR ₹',
  USD: '🇺🇸 USD $'
}
